/* This is the EMIS Staff Education components */

<template>
  <v-container>
    <div>
			<span v-html="title"></span>
      <HelpIcon :help="htext"/>
		</div>
		<div>
      <table style="height: 116px;" border="1px;" cellspacing="0px;">
        <tbody>
          <tr style="height: 35px;">
            <td style="width: 102px; height: 90px; text-align: center; vertical-align: middle;" rowspan="2">កម្រិតវប្បធម៌/ជំនាញ</td>
            <td style="width: 150px; text-align: center; vertical-align: middle; height: 35px;" colspan="3">បុគ្គលិកបង្រៀន</td>
            <td style="width: 150px; text-align: center; vertical-align: middle; height: 35px;" colspan="3">បុគ្គលិកមិនបង្រៀន</td>
          </tr>
          <tr style="height: 55px;">
            <td style="width: 150px; text-align: center; vertical-align: middle; height: 55px;">សរុប</td>
            <td style="width: 150px; text-align: center; vertical-align: middle; height: 55px;">ស្រី</td>
            <td style="width: 102px; text-align: center; vertical-align: middle; height: 55px;">មិនបានបណ្ដុះបណ្ដាលគរុកោសល្យ</td>

            <td style="width: 150px; text-align: center; vertical-align: middle; height: 55px;">សរុប</td>
            <td style="width: 150px; text-align: center; vertical-align: middle; height: 55px;">ស្រី</td>
            <td style="width: 104px; text-align: center; vertical-align: middle; height: 55px;">មិនបានបណ្ដុះបណ្ដាលគរុកោសល្យ</td>
          </tr>
          <tr v-for="(value, row) in d3.length" :key="row" style="height: 25px;">
            <td
              style="width: 220px; height: 25px; text-align: left; vertical-align: middle;"
            >{{ d3[row] }}</td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">
              <numberinput v-model="data[row].dt[0]" style="width:50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">
              <numberinput v-model="data[row].dt[1]" style="width:50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">
              <numberinput v-model="data[row].dt[2]" style="width:50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">
              <numberinput v-model="data[row].dt[3]" style="width:50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">
              <numberinput v-model="data[row].dt[4]" style="width:50px; text-align: center;" />
            </td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">
              <numberinput v-model="data[row].dt[5]" style="width:50px; text-align: center;" />
            </td>            
          </tr>
          <!-- Total staff row -->
          <tr>
            <td style="width: 220px; height: 25px; text-align: left; vertical-align: middle;">សរុប</td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">
              {{totalRow[0]}}
            </td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">
              {{totalRow[1]}}
            </td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">
              {{totalRow[2]}}
            </td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">
              {{totalRow[3]}}
            </td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">
              {{totalRow[4]}}
            </td>
            <td style="width: 60px; height: 25px; text-align: center; vertical-align: middle;">
              {{totalRow[5]}}
            </td>            
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { d3 } from "@/utils/ascf/commonConfig.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title", "htext"],
  components: {
    numberinput: NumberInput
  },
  data() {
    return {
      d3: d3
    };
	},
	computed: {
		// need to update the total staff in json data
    totalRow: function () {
      let result = [];

      this.data.forEach(function (a) {
          a.dt.forEach(function (b, i) {
              result[i] = (result[i] || 0) + Number(b);
          });
      });

      return result;
    },
    /*
		totalRow: function () {	
			let result
			let d = this.data
			let ldata = this.data.length - 1

			result = d.reduce(function (r, a, ind) {
				a.dt.forEach(function (b, i) {
					if (ind < ldata) { // do summing 0 to last - 1 only (last is sum array)
            r[i] = (r[i] || 0) + Number(b)
          }
				})
				return r
			}, [])
			// update the total row array in JSON
			d[ldata].dt.forEach(function (b, i) {
        d[ldata].dt[i] = result[i]
			})
      return result
		}
    */
	}
}
</script>
<style scoped>

</style>